import React, { useState } from 'react';

import { useStyles } from 'features/my-gift-cards/components/AddGiftCard/styles';
import { Paper } from 'features/app/components/Paper';
import BaseButton from 'features/app/components/BaseButton';
import { myGiftCardsPaths } from 'features/my-gift-cards/routes/paths';
import { useTranslation } from 'hooks/useTranslation';
import { Search } from 'features/app/components/Search';
import { Box } from '@material-ui/core';

interface AddGiftCardProps {
  onChange: (value: string) => void;
}

export const AddGiftCard: React.FC<AddGiftCardProps> = ({ onChange }) => {
  const classes = useStyles();
  const [searchValue, setSearchValue] = useState<string>('');

  const { t } = useTranslation('my-gift-cards');

  return (
    <Paper className={classes.root}>
      <Box className={classes.buttonWrapper}>
        <BaseButton className={classes.addButton} to={myGiftCardsPaths.dynamic.card('new')}>
          {t('addNewReward')}
        </BaseButton>
      </Box>
      <Search
        containerClass={classes.searchInput}
        value={searchValue}
        onChange={value => {
          setSearchValue(value as string);
          onChange(value as string);
        }}
      />
    </Paper>
  );
};
